import { Box } from '@chakra-ui/react';
import { BrokerType, brokerTypes, freedomTypes } from 'enums/shared/brokerType';
import useBrokerLogo from 'hooks/modules/brokerAccount/useBrokerLogo';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import SelectBrokerItem from 'presentation/components/modules/brokerAccount/create/SelectBrokerItem';
import SettingsLayout from 'presentation/layout/modules/settings/SettingsLayout';
import AppCard from 'presentation/components/shared/card/AppCard';
import AppRoute from 'router/AppRoute';
import GridHeading from 'presentation/components/shared/grid/GridHeading';

const SelectBrokerAccountPage: FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const getBrokerLogo = useBrokerLogo({
    isFullLogo: true,
  });

  const navigatePaths = {
    [BrokerType.Tinkoff]: AppRoute.connectTinkoffBroker,
    [BrokerType.Tradernet]: AppRoute.connectTradernetBroker,
    [BrokerType.Finam]: AppRoute.connectFinamBroker,
    [BrokerType.Binance]: AppRoute.connectBinanceBroker,
    [BrokerType.PE]: AppRoute.brokerList,
    [BrokerType.Crypto]: AppRoute.brokerList,
    [BrokerType.Arbitr]: AppRoute.brokerList,
    [BrokerType.IPO]: AppRoute.brokerList,
    [BrokerType.NVB]: AppRoute.brokerList,
    [BrokerType.CryptoDeposit]: AppRoute.brokerList,
    [BrokerType.PrimeIPO]: AppRoute.brokerList,
  };

  return (
    <SettingsLayout>
      <Helmet>
        <title>{t('connectBrokerAccountTitle')}</title>
      </Helmet>
      <GridHeading>{t('selectBrokerTitle')}</GridHeading>
      <AppCard p="40px" mb="20px" fontWeight={700}>
        {t('selectBrokerDescription')}
      </AppCard>
      {brokerTypes.map((broker) => {
        if (broker !== BrokerType.Freedom) {
          return <Box key={broker} mb="20px">
            <SelectBrokerItem
              logo={getBrokerLogo({ brokerType: broker })}
              onClick={() => navigate(navigatePaths[broker])}
            />
          </Box>;
        } else {
          return <Box key={broker}/>;
        }
      })}
      {freedomTypes.map((freedom) => (
          <Box key={freedom} mb="20px">
            <SelectBrokerItem
              logo={getBrokerLogo({ brokerType: BrokerType.Freedom, freedomType: freedom })}
              onClick={() => navigate(AppRoute.connectFreedomBroker(freedom))}
            />
          </Box>
      )
      )}
    </SettingsLayout>
  );
};

export default SelectBrokerAccountPage;
